module.exports = __webpack_public_path__ + "img/d.6a4054d5.jpg";